export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-trip-progress-1200-458d6468485aadf7c0d26cddf36beda4.png";